/**
 * The wiki's languages.
 *
 * `ro` is the source every document is written in; `en` is the fallback for a
 * text another language has no translation of yet. URL codes are ISO 639-1;
 * the Gameforge name tables in docs/Item-Mob-Names use their own codes, and
 * `gameforge` records the mapping plus the legacy code page those files are in.
 */
export const SOURCE_LOCALE = 'ro'
export const FALLBACK_LOCALE = 'en'

export const LOCALES = [
  {
    code: 'ar',
    name: 'العربية',
    english: 'Arabic',
    gameforge: 'ae',
    codepage: 'windows-1256',
  },
  {
    code: 'ro',
    name: 'Română',
    english: 'Romanian',
    gameforge: 'ro',
    codepage: 'windows-1250',
  },
  {
    code: 'en',
    name: 'English',
    english: 'English',
    gameforge: 'en',
    codepage: 'windows-1252',
  },
  {
    code: 'de',
    name: 'Deutsch',
    english: 'German',
    gameforge: 'de',
    codepage: 'windows-1252',
  },
  {
    code: 'fr',
    name: 'Français',
    english: 'French',
    gameforge: 'fr',
    codepage: 'windows-1252',
  },
  {
    code: 'es',
    name: 'Español',
    english: 'Spanish',
    gameforge: 'es',
    codepage: 'windows-1252',
  },
  {
    code: 'it',
    name: 'Italiano',
    english: 'Italian',
    gameforge: 'it',
    codepage: 'windows-1252',
  },
  {
    code: 'pt',
    name: 'Português',
    english: 'Portuguese',
    gameforge: 'pt',
    codepage: 'windows-1252',
  },
  {
    code: 'pl',
    name: 'Polski',
    english: 'Polish',
    gameforge: 'pl',
    codepage: 'windows-1250',
  },
  {
    code: 'cs',
    name: 'Čeština',
    english: 'Czech',
    gameforge: 'cz',
    codepage: 'windows-1250',
  },
  {
    code: 'hu',
    name: 'Magyar',
    english: 'Hungarian',
    gameforge: 'hu',
    codepage: 'windows-1250',
  },
  {
    code: 'el',
    name: 'Ελληνικά',
    english: 'Greek',
    gameforge: 'gr',
    codepage: 'windows-1253',
  },
  {
    code: 'tr',
    name: 'Türkçe',
    english: 'Turkish',
    gameforge: 'tr',
    codepage: 'windows-1254',
  },
]

export const LOCALE_CODES = LOCALES.map((l) => l.code)

/** Every language but the source. */
export const TARGET_LOCALES = LOCALE_CODES.filter((c) => c !== SOURCE_LOCALE)

export const RTL_LOCALES = new Set(['ar'])
